<div class="instruction-form-wrap">
  <div class="add-instruction-container">
    <div class="btn-close">
      <h2 mat-dialog-title>Instructions</h2>
      <mat-icon (click)="onClose()">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div class="row">
      <div class="col-md-12 editor-cls">
        <div class="mb-3">
          <!-- <textarea class="form-control" rows="3" readonly></textarea> -->
          <p>{{instruction}}</p>
        </div>
      </div>
    </div>
    <div class="send-instruction-message">
      <button mat-raised-button (click)="onClose()">Close</button>
    </div>
  </div>
</div>
